import React, { useEffect } from 'react';
import { AuthProvider } from '../contexts/AuthContext';
import { FeaturesProvider } from '../contexts/FeaturesContext';
import { SettingsProvider } from '../contexts/SettingsContext';
import { ThemeProvider } from '../themes';
import { MenuProvider } from '../contexts/MenuContext';
import { UpgradeFlowProvider } from '../contexts/UpgradeFlowContext';
import { ApiSyncManager } from './ApiSyncManager';
import { CLOUD_FEATURES_ENABLED } from '../constants/config';
import { migrateStorage } from '../utils/migrations';
import { logger } from '../utils/logger';

interface ProvidersProps {
  children: React.ReactNode;
}

export const Providers: React.FC<ProvidersProps> = ({ children }) => {
  // Run storage schema migrations from EVERY view's shared init path, not just
  // the side panel — popup/fullscreen/settings-only users must get them too.
  // migrateStorage is versioned and idempotent, so repeat calls are no-ops.
  useEffect(() => {
    migrateStorage().catch(error => {
      logger.error(
        'Storage migration failed',
        error instanceof Error ? error : new Error(String(error)),
        { module: 'Providers', function: 'migrateStorage' }
      );
    });
  }, []);

  return (
    <AuthProvider>
      {/* Runs cloud sync from open UI surfaces; only mounted once the API +
          Firebase are configured. */}
      {CLOUD_FEATURES_ENABLED ? <ApiSyncManager /> : null}
      <FeaturesProvider>
        <SettingsProvider>
          <ThemeProvider>
            {/* Inside ThemeProvider (its dialog uses theme colors) and
                AuthProvider (it reacts to sign-in) so every surface can
                start the account-gated upgrade flow (ADR-011). */}
            <UpgradeFlowProvider>
              <MenuProvider>{children}</MenuProvider>
            </UpgradeFlowProvider>
          </ThemeProvider>
        </SettingsProvider>
      </FeaturesProvider>
    </AuthProvider>
  );
};
